import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Markdown from 'markdown-to-jsx';

const MarkdownToHtml = memo(({ markdown = '', options }) => {
  const normalizedMarkdown = markdown.replace(/\r\n\s*/g, '  \n').trim(); // https://github.com/quantizor/markdown-to-jsx/blob/5b80921fe62f37ac676ff4661739a3d0701d765a/index.tsx#L182

  return <Markdown options={options}>{normalizedMarkdown}</Markdown>;
});

MarkdownToHtml.displayName = `MarkdownToHtml`;

MarkdownToHtml.propTypes = {
  markdown: PropTypes.string,
  options: PropTypes.object
};

export default MarkdownToHtml;
